import { createFragmentContainer, graphql } from 'react-relay';
import Share from './Share';

export default createFragmentContainer(Share, {
  event: graphql`
    fragment Share_event on Event {
      user_contacts {
        edges {
          node {
            first_name
            last_name
            user_contact_emails {
              edges {
                node {
                  address
                }
              }
            }
          }
        }
      }
    }
  `,
});



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/Actions/Share/index.js